import type { Locale, TranslationDictionary } from '../data/types';
import en from './en';
import vi from './vi';

const dictionaries: Record<Locale, TranslationDictionary> = { vi, en };

export function translate(locale: Locale, key: string): string {
  const dict = dictionaries[locale];
  return (
    dict.ui[key] ??
    dict.scenes[key] ??
    dict.groups[key] ??
    dict.journeys[key] ??
    key
  );
}

export function sceneLabel(locale: Locale, sceneId: string): string {
  return translate(locale, `scenes.${sceneId}`);
}

export function groupLabel(locale: Locale, groupId: string): string {
  return translate(locale, `groups.${groupId}`);
}

export { dictionaries };
